import * as React from 'react';
import * as moment from 'moment';

import { IEvent } from '../custom/classes/event';
import { ICalendarState, IMonth, CalendarViewMode, CalendarDeviceMode } from '../classes/calendar';
import { connect } from 'react-redux';

import CalendarContainerView from 'calendar-container.view';
import { ICalendarAppState } from '../redux-state';

interface ICalendarContainerExternalProps {

}

interface StateToProps {
    calendarViewMode: CalendarViewMode;
    calendarDeviceMode: CalendarDeviceMode;
    isLoading: boolean;
}

export type CalendarContainerProps = ICalendarContainerExternalProps & StateToProps;

export class CalendarContainerBase extends React.Component<CalendarContainerProps, any> {

    componentDidUpdate(prevProps: CalendarContainerProps) {
        const superParent = document.documentElement;

        if (this.props.isLoading) {
            // attribute removal happens in the views of the components that trigger loading states.
            // removal should happen after all other callback functionality.
            superParent.setAttribute("data-calendar-loading", "true");
        }
    }

    render() {
        return (
            <CalendarContainerView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: ICalendarContainerExternalProps): StateToProps {
    return {
        calendarViewMode: state.calendarSettings.calendarViewMode,
        calendarDeviceMode: state.calendarSettings.calendarDeviceMode,
        isLoading: state.calendar.updating
    }
}

export default connect<StateToProps>(mapStateToProps)(CalendarContainerBase);